import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  getUnitholders, getUnitholdersSuccess, getUnitholdersFailure,
  getAllocationMutualFund, getAllocationMutualFundSuccess, getAllocationMutualFundFailure, 
  getAllocationMutualFundByUnitholder, getAllocationMutualFundByUnitholderSuccess, getAllocationMutualFundByUnitholderFailure,
  setStrategyLoading, setAllocationFocus, setModelPortDocument
  
  
} from "redux/reducers/model-portfolio";
import { ModelPortfolioSelector } from "redux/selector/model-portfolio-selector";
import { ModelPortfolioAPI } from "services/model-portfolio";

function* getUnitholdersSaga() {
  try {
    const response = yield call(ModelPortfolioAPI.getUnitholders);
    yield put(getUnitholdersSuccess(response.data.unitholder?.unitholderList || []));
  } catch (error) {
    yield put(getUnitholdersFailure(error));
  }
}

function* getAssetAllocationSaga() {
  try {
    const response = yield call(ModelPortfolioAPI.getAllocationMutualFund, {});
    yield put(getAllocationMutualFundSuccess(response.data.strategyList || []));
    yield put(setModelPortDocument({
      url: response.data?.detail?.fileLocation,
      filename: response.data?.detail?.fileName,
    }));
  } catch (error) {
    yield put(getAllocationMutualFundFailure(error));
  }
}

function* getAllocationByUnitholderSaga() {
  try {
    const filterUnitholder = yield select(ModelPortfolioSelector.filterUnitholder);
    const currentCriteries = yield select(ModelPortfolioSelector.strategyCriteries);
    const unitholders = yield select(ModelPortfolioSelector.unitholders);
    const criteries = {
      unitholder: filterUnitholder?.join(",") || null
    }
    const assumeAllSelectUnitholderLikeNullFilter = 
      currentCriteries?.unitholder === null
      && criteries.unitholder === unitholders.map(u => u.unitholderNo).join(",") // select all
    if (
      (criteries.unitholder !== currentCriteries?.unitholder)
      && !assumeAllSelectUnitholderLikeNullFilter
    ) {
      yield put(setStrategyLoading(true))
      const response = yield call(ModelPortfolioAPI.getAllocationMutualFund, criteries);
      const strategyList = response.data.strategyList ?? [];
      yield put(getAllocationMutualFundByUnitholderSuccess({
        strategyList,
        criteries,
      }));
      const strategyDefault = strategyList?.find(strategy => strategy.asDefault) ?? strategyList?.[0];
      if (strategyDefault) {
        yield put(setAllocationFocus(strategyDefault.allocStrategyName));
      }
    } else {
      yield put(setStrategyLoading(false))
    }
  } catch (error) {
    yield put(getAllocationMutualFundByUnitholderFailure(error));
  }
}

const saga = [
  takeLatest(getUnitholders.type, getUnitholdersSaga),
  takeLatest(getAllocationMutualFund.type, getAssetAllocationSaga),
  takeLatest(getAllocationMutualFundByUnitholder.type ,getAllocationByUnitholderSaga)

];

export default saga;
